import React, { useState, } from 'react';
import { columns, mobileColumns } from './CommentReqReportColumn';
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable';
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize';
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable';
import ReportFooter from '../../ReportsFooter/ReportFooter';

function formatDate(dateString) {
  if (!dateString) return 'Invalid Date';
  const date = new Date(dateString);
  return isNaN(date)
    ? 'Invalid Date'
    : date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

const CommentReqReportTable = ({
  isLoading,
  data,
  dates,
  totaldata,
  downloadPDF,
  downloadExcel,
  handleColumnSort,
  pageCount,
  tableOptions,
  handlePageClick,
  handleRowsPerPage,
  reportData,
  reportCode,
  reportTableData,
  generatePDFFunction,
}) => {
  const size = useWindowSize();
  const [currentRow, setCurrentRow] = useState(null);

  const formattedStartDate = formatDate(dates?.startDate);
  const formattedEndDate = formatDate(dates?.endDate);

  if (size.width < 768) {
    return (
      <>
        <h1 className="mb-4">Comment Request Report</h1>
        <h6 className="text-muted mb-4 fw-normal">
          The grid below shows data for requests created between {formattedStartDate} and {formattedEndDate}.
        </h6>
        <ReactExpandableTable
          isLoading={isLoading}
          setCurrentRow={setCurrentRow}
          mobileColumns={mobileColumns}
          currentRow={currentRow}
          data={data}
          totaldata={totaldata}
          pageCount={pageCount}
          activePage={tableOptions?.activePage}
          rowPerPages={tableOptions?.rowPerPages}
          handleColumnSort={handleColumnSort}
          handleRowsPerPage={handleRowsPerPage}
          removePagination={true}
          handlePageClick={handlePageClick}
        />
        <ReportFooter
          BackText="Back"
          PdfText="PDF"
          MailText="Mail"
          ExcelText="Excel"
          onPdfClick={downloadPDF}
          onExcelClick={downloadExcel}
           reportCode={reportCode}
        />
      </>
    );
  }

  return (
    <>
      <h1 className="mb-2">Comment Request Report</h1>
      <h6 className="text-muted mb-4 fw-normal">
        The grid below shows data for requests created between {formattedStartDate} and {formattedEndDate}.
      </h6>
      <ReactDataTable
        isLoading={isLoading}
        data={data}
        columns={columns}
        pageCount={pageCount}
        activePage={tableOptions?.activePage}
        rowPerPages={tableOptions?.rowPerPages}
        totaldata={totaldata}
        handleRowsPerPage={handleRowsPerPage}
        removePagination={false}
        handleColumnSort={handleColumnSort}
        handlePageClick={handlePageClick}
      />
      <ReportFooter
        BackText="Back"
        PdfText="PDF"
        MailText="Mail"
        ExcelText="Excel"
        onPdfClick={downloadPDF}
        onExcelClick={downloadExcel}
        reportData={reportData}
        reportCode={reportCode}
        reportTableData={reportTableData}
        generatePDFFunction={generatePDFFunction}
      />
    </>
  );
};

export default CommentReqReportTable;
